import React, { useMemo, useRef, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  InputBase,
  Menu,
  MenuItem,
  Fab,
  Link
} from "@material-ui/core";
import {  useEffect } from 'react';
import {
  Menu as MenuIcon,
  Person as AccountIcon,
  School as SchoolIcon,
  SupervisorAccount as SupervisorIcon,
  Face as ParentIcon,
  EmojiPeople as TeacherIcon,
  Send as SendIcon,
  ArrowBack as ArrowBackIcon,
  BuildTwoTone,
} from "@material-ui/icons";
import classNames from "classnames";

// styles
import useStyles from "./styles";

// components
import {  Typography, Button } from "../Wrappers";
import Notification from "../Notification/Notification";
import UserAvatar from "../UserAvatar/UserAvatar";
import SchoolService from "../../pages/dashboard/Locality/Service/schoolService";
import { Link as RouterLink } from "react-router-dom";

// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
} from "../../context/LayoutContext";
import { useUserDispatch, signOut } from "../../context/UserContext";

const messages = [
  {
    id: 0,
    variant: "warning",
    name: "Jane Hew",
    message: "Hey! How is it going?",
    time: "9:32",
  },
  {
    id: 1,
    variant: "success",
    name: "Lloyd Brown",
    message: "Check out my new Dashboard",
    time: "9:18",
  },
  {
    id: 2,
    variant: "primary",
    name: "Mark Winstein",
    message: "I want rearrange the appointment",
    time: "9:15",
  },
  {
    id: 3,
    variant: "secondary",
    name: "Liana Dutti",
    message: "Good news from sale department",
    time: "9:09",
  },
];

const notifications = [
  { id: 0, color: "warning", message: "Check out this awesome ticket" },
  {
    id: 1,
    color: "success",
    type: "info",
    message: "What is the best way to get ...",
  },
  {
    id: 2,
    color: "secondary",
    type: "notification",
    message: "This is just a simple notification",
  },
  {
    id: 3,
    color: "primary",
    type: "e-commerce",
    message: "12 new orders has arrived today",
  },
];

export default function Header(props) {
  var classes = useStyles();

  // global
  var layoutState = useLayoutState();
  var layoutDispatch = useLayoutDispatch();
  var userDispatch = useUserDispatch();

  // local
  var [mailMenu, setMailMenu] = useState(null);
  var [isMailsUnread, setIsMailsUnread] = useState(true);
  var [notificationsMenu, setNotificationsMenu] = useState(null);
  var [isNotificationsUnread, setIsNotificationsUnread] = useState(true);
  var [profileMenu, setProfileMenu] = useState(null);
  const [fontSize, setFontSize] = useState("2.5rem");
  const [schoolLogo, setSchoolLogo] = useState(null);
  const [schoolName, setSchoolName] = useState(null);
  // Parse once per render from a stable string (prevents effect refires due to new object identity)
  const userDetailsRaw = localStorage.getItem("userDetail") || "";
  const userDetails = useMemo(() => {
    try {
      return userDetailsRaw ? JSON.parse(userDetailsRaw) : {};
    } catch {
      return {};
    }
  }, [userDetailsRaw]);

  const schooleId = useMemo(() => {
    const id = userDetails?.schooleId || userDetails?.schoolId;
    return id && typeof id === "object" ? id?._id : id;
  }, [userDetails]);

  const shouldFetchSchool = useMemo(
    () =>
      Boolean(
        userDetails &&
          (userDetails.role === "SCHOOLE" ||
            userDetails.role === "TEACHER" ||
            userDetails.role === "PARENT") &&
          schooleId,
      ),
    [userDetails, schooleId],
  );

  const lastFetchedSchoolIdRef = useRef(null);
  const schoolFetchInFlightRef = useRef(false);
  const displayName =
    (userDetails && (userDetails.name || userDetails.userName || userDetails.email)) || "";
  
  useEffect(() => {
    const handleResize = () => {
      setFontSize(window.innerWidth < 600 ? "1.75rem" : "2.5rem");
    };
    window.addEventListener("resize", handleResize);
    handleResize(); 
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // Fetch school logo and name for schoole, teacher, and parent roles
    // Guarded to prevent duplicate fetches on re-renders / StrictMode.
    if (!shouldFetchSchool) return;
    if (schoolFetchInFlightRef.current) return;
    if (lastFetchedSchoolIdRef.current === String(schooleId)) return;

    schoolFetchInFlightRef.current = true;
    lastFetchedSchoolIdRef.current = String(schooleId);

    SchoolService.getSchooleRegistrationById(schooleId)
      .then((res) => {
        if (res?.logo) setSchoolLogo(res.logo);
        if (res?.schooleName) setSchoolName(res.schooleName);
      })
      .catch((err) => {
        console.error("Error fetching school details:", err);
      })
      .finally(() => {
        schoolFetchInFlightRef.current = false;
      });
  }, [shouldFetchSchool, schooleId]);
  // style={{ backgroundColor: 'rgb(255, 92, 147)', color: 'white' }}
  return (
<AppBar
      position="fixed"
      className={classes.appBar}
      style={{ backgroundColor: "white", border: "none", height: "80px",  }}
    >    
    
      <Toolbar className={classes.toolbar} style={{paddingBottom:"40px"}}>
      {/* <button   onClick={() => toggleSidebar(layoutDispatch)}>click</button> */}
      {/* <div className={classes.mobileBackButton}>
          <IconButton onClick={() => toggleSidebar(layoutDispatch)}>
            <MenuIcon /> 
          </IconButton>
        </div> */}
      {layoutState.isSidebarOpened ? (
             <IconButton onClick={() => toggleSidebar(layoutDispatch)}>
             <MenuIcon /> 
           </IconButton>
          ) : (
            <IconButton onClick={() => toggleSidebar(layoutDispatch)}>
             <MenuIcon /> 
           </IconButton>
          )}
      <div className={classes.logoContainer}>
          <img
            src="https://artistimages.blob.core.windows.net/montestory/logo 2.svg"
            alt="logo"
            className={classes.logoImage} style={{width:"75px"}}
          />
          
        </div>
        <Typography
      variant="h6"
      weight="medium"
      style={{
        fontSize: fontSize,
        fontWeight: "700",
        color: "#0F3B62",
        width: "100%",
      }}
    >
      <span style={{ color: "#0F3B62" }}>Monte</span><span style={{ color: "#E8B923" }}>story</span>
    </Typography>     
       {/* <IconButton
          color="inherit"
          onClick={() => toggleSidebar(layoutDispatch)}
          className={classNames(
            classes.headerMenuButtonSandwich,
            classes.headerMenuButtonCollapse,
          )}
        >

          {layoutState.isSidebarOpened ? (
            <ArrowBackIcon
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse,
                ),
              }}
            />
          ) : (
            <MenuIcon
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse,
                ),
              }}
            />
          )}
        </IconButton> */}
        {/* <Typography variant="h6" weight="medium" className={classes.logotype} style={{ fontSize:"calc(2.1rem)", fontWeight:"400", }}>
        <img
            src="https://artistimages.blob.core.windows.net/montestory/logo 2.svg"
            alt="logo"
            style={{ width: "85px", height: "auto", marginTop: "8px" }}
          /> 
        </Typography> */}
       
        <div className={classes.grow} />

        <div style={{ display: "flex", alignItems: "center", gap: 16, marginRight: 12 }}>
          <Link component={RouterLink} to="/montessori/about" color="inherit" underline="none">
            About Us
          </Link>
          <Link component={RouterLink} to="/montessori/contact" color="inherit" underline="none">
            Contact Us
          </Link>
        </div>


      

        
        {/* <Button component={Link} href="https://flatlogic.com/templates/react-material-admin-full" variant={"outlined"} color={"secondary"} className={classes.purchaseBtn}>Unlock full version</Button> */}
        
        {/* <IconButton
          color="inherit"
          aria-haspopup="true"
          aria-controls="mail-menu"
          onClick={e => {
            setNotificationsMenu(e.currentTarget);
            setIsNotificationsUnread(false);
          }}
          className={classes.headerMenuButton}
        >
         
        </IconButton> */}
        <IconButton
          color="inherit"
          aria-haspopup="true"
          aria-controls="mail-menu"
          onClick={e => {
            setMailMenu(e.currentTarget);
            setIsMailsUnread(false);
          }}
          className={classes.headerMenuButton}
        >
         
        </IconButton>
        {(schoolLogo || schoolName) && (userDetails?.role === 'SCHOOLE' || userDetails?.role === 'TEACHER' || userDetails?.role === 'PARENT') && (
          <div 
            style={{
              display: "flex",
              alignItems: "center",
              marginLeft: "8px",
              cursor: "pointer",
              padding: "4px 8px",
              borderRadius: "4px",
              transition: "background-color 0.2s"
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f5f5f5"}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
            onClick={e => setProfileMenu(e.currentTarget)}
          >
            {schoolLogo && (
              <img
                src={schoolLogo}
                alt="School Logo"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: "2px solid #0f3b62",
                  marginRight: "8px"
                }}
              />
            )}
            {schoolName && (
              <Typography
                variant="body1"
                style={{
                  color: "#0f3b62",
                  fontWeight: "700",
                  fontSize: "23px",
                  maxWidth: "400px",
                  overflow: "visible",
                  textOverflow: "clip",
                  whiteSpace: "nowrap"
                }}
                title={schoolName}
              >
                {schoolName}
              </Typography>
            )}
          </div>
        )}
        <IconButton  
          style={{
            backgroundColor: "#0f3b62",
            marginLeft: "8px",
            padding: "8px",
            minWidth: "40px",
            minHeight: "40px"
          }}
          aria-haspopup="true"
          color="inherit"
          className={`${classes.headerMenuButton} ${classes.profileMenuButton}`}
          aria-controls="profile-menu"
          onClick={e => setProfileMenu(e.currentTarget)}
        >
          <AccountIcon 
            style={{ 
              fontSize: "24px", 
              color: "white" 
            }} 
          />
        </IconButton>
        <Menu 
          id="mail-menu"
          open={Boolean(mailMenu)}
          anchorEl={mailMenu}
          onClose={() => setMailMenu(null)}
          MenuListProps={{ className: classes.headerMenuList }}
          className={classes.headerMenu}
          classes={{ paper: classes.profileMenu }}
          disableAutoFocusItem
        >
          <div className={classes.profileMenuUser}>
            <Typography variant="h4" weight="medium">
              New Messages
            </Typography>
            <Typography 
              className={classes.profileMenuLink}
              component="a"
              color="secondary"
            >
              {messages.length} New Messages
            </Typography>
          </div>
          {/* {messages.map(message => (
            <MenuItem key={message.id} className={classes.messageNotification}>
              <div className={classes.messageNotificationSide}>
                <UserAvatar color={message.variant} name={message.name} />
                <Typography size="sm" color="text" colorBrightness="secondary">
                  {message.time}
                </Typography>
              </div>
              <div
                className={classNames(
                  classes.messageNotificationSide,
                  classes.messageNotificationBodySide,
                )}
              >
                <Typography weight="medium" gutterBottom>
                  {message.name}
                </Typography>
                <Typography color="text" colorBrightness="secondary">
                  {message.message}
                </Typography>
              </div>
            </MenuItem>
          ))} */}
          <Fab 
            variant="extended"
            color="primary"
            aria-label="Add"
            className={classes.sendMessageButton}
          >
            Send New Message
            <SendIcon className={classes.sendButtonIcon} />
          </Fab>
        </Menu>
        {/* <Menu
          id="notifications-menu" 
          open={Boolean(notificationsMenu)}
          anchorEl={notificationsMenu}
          onClose={() => setNotificationsMenu(null)}
          className={classes.headerMenu}
          disableAutoFocusItem
        >
          {notifications.map(notification => (
            <MenuItem
              key={notification.id}
              onClick={() => setNotificationsMenu(null)}
              className={classes.headerMenuItem}
            >
              <Notification {...notification} typographyVariant="inherit" />
            </MenuItem>
          ))}
        </Menu> */}
        <Menu 
          id="profile-menu"
          open={Boolean(profileMenu)}
          anchorEl={profileMenu}
          onClose={() => setProfileMenu(null)}
          className={classes.headerMenu}
          classes={{ paper: classes.profileMenu }}
          disableAutoFocusItem
        >
          <div className={classes.profileMenuUser}>
            <Typography variant="h4" weight="medium">
              {displayName}
            </Typography>
            {userDetails.role && (
              <div style={{ display: "flex", alignItems: "center", marginTop: 2, gap: 6 }}>
                {String(userDetails.role).toUpperCase() === "SCHOOLE" && (
                  <SchoolIcon style={{ fontSize: 18, color: "#1d4ed8" }} />
                )}
                {String(userDetails.role).toUpperCase() === "SUPERADMIN" && (
                  <SupervisorIcon style={{ fontSize: 18, color: "#b91c1c" }} />
                )}
                {String(userDetails.role).toUpperCase() === "TEACHER" && (
                  <TeacherIcon style={{ fontSize: 18, color: "#15803d" }} />
                )}
                {String(userDetails.role).toUpperCase() === "PARENT" && (
                  <ParentIcon style={{ fontSize: 18, color: "#92400e" }} />
                )}
                <Typography
                  variant="subtitle2"
                  style={{ color: "#64748b", fontWeight: 600 }}
                >
                  {String(userDetails.role).toLowerCase() === "schoole"
                    ? "School Admin"
                    : String(userDetails.role).charAt(0).toUpperCase() + String(userDetails.role).slice(1).toLowerCase()}
                </Typography>
              </div>
            )}
            <Typography
              className={classes.profileMenuLink}
              component="span"
              color="primary"
            >
              {userDetails.email}
            </Typography>
          </div>
          {/* <MenuItem
            className={classNames(
              classes.profileMenuItem,
              classes.headerMenuItem,
            )}
          >
            <AccountIcon className={classes.profileMenuIcon} /> Profile
          </MenuItem>
          <MenuItem
            className={classNames(
              classes.profileMenuItem,
              classes.headerMenuItem,
            )}
          >
            <AccountIcon className={classes.profileMenuIcon} /> Tasks
          </MenuItem>
          <MenuItem
            className={classNames(
              classes.profileMenuItem,
              classes.headerMenuItem,
            )}
          >
            <AccountIcon className={classes.profileMenuIcon} /> Messages
          </MenuItem> */}
          <div className={classes.profileMenuUser}>
            <Typography 
              className={classes.profileMenuLink}
              color="primary"
              onClick={() => signOut(userDispatch, props.history)}
            >
              Sign Out
            </Typography>
          </div>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}
